module.exports = __webpack_public_path__ + "fonts/Roboto-Light.0f8d7fc.woff";